const language = {
    'pt':
    {
        tipo_de_perfil: 'Tipo de Perfil',
        menus_perfis: 'Home / Perfis / Lista de Perfis',
        add_new: 'Novo Perfil',
        perfil: 'Perfil',
        perfis: 'Perfis',
    },
    'en':
    {
        tipo_de_perfil: 'Profile Type',
        menus_perfis: 'Home / Profiles / Profile List',
        add_new: 'New Profile',
        perfil: 'Profile',
        perfis: 'Profiles',
    },
    'es':
    {
        tipo_de_perfil: 'Tipo de perfil',
        menus_perfis: 'Inicio / Perfiles / Lista de perfiles',
        add_new: 'Nuevo perfil',
        perfil: 'Perfil',
        perfis: 'Perfiles',
    },
    'fr':
    {
        tipo_de_perfil: 'Type de profil',
        menus_perfis: 'Accueil / Profils / Liste des profils',
        add_new: 'Nouveau profil',
        perfil: 'Profil',
        perfis: 'Profils', 
    }
}

module.exports = {
    language
};